import { vehicleRegistrationServicetoUiAdapter } from '../../../adapters';
import { parkingSplitApi } from '../apiBase';
export var vehicleRegistrationApi = parkingSplitApi.injectEndpoints({
    overrideExisting: true,
    endpoints: function (builder) { return ({
        getVehicleDetails: builder.query({
            query: function (_a) {
                var apiRegistrationUrlDomain = _a.apiRegistrationUrlDomain, regionId = _a.regionId, apiRegistrationUrlSubString = _a.apiRegistrationUrlSubString, requestParams = _a.requestParams;
                return ({
                    url: "".concat(apiRegistrationUrlDomain).concat(regionId).concat(apiRegistrationUrlSubString, "/").concat(requestParams),
                    method: 'GET',
                });
            },
            transformResponse: function (response) {
                return vehicleRegistrationServicetoUiAdapter(response);
            },
            keepUnusedDataFor: 1,
        }),
        postVehicleDetails: builder.mutation({
            query: function (_a) {
                var apiRegistrationUrlDomain = _a.apiRegistrationUrlDomain, regionId = _a.regionId, apiRegistrationUrlSubString = _a.apiRegistrationUrlSubString, postRequestData = _a.postRequestData;
                return ({
                    url: "".concat(apiRegistrationUrlDomain).concat(regionId).concat(apiRegistrationUrlSubString),
                    method: 'POST',
                    body: postRequestData,
                    invalidates: ['Posts'],
                });
            },
        }),
        updateVehicleDetails: builder.mutation({
            query: function (_a) {
                var apiRegistrationUrlDomain = _a.apiRegistrationUrlDomain, regionId = _a.regionId, apiRegistrationUrlSubString = _a.apiRegistrationUrlSubString, updateRequestData = _a.updateRequestData;
                return ({
                    url: "".concat(apiRegistrationUrlDomain).concat(regionId).concat(apiRegistrationUrlSubString, "/").concat(updateRequestData.registrationId),
                    method: 'PUT',
                    body: updateRequestData,
                });
            },
        }),
        deleteVehicleDetails: builder.mutation({
            query: function (_a) {
                var apiRegistrationUrlDomain = _a.apiRegistrationUrlDomain, regionId = _a.regionId, apiRegistrationUrlSubString = _a.apiRegistrationUrlSubString, requestParams = _a.requestParams;
                return ({
                    url: "".concat(apiRegistrationUrlDomain).concat(regionId).concat(apiRegistrationUrlSubString, "/").concat(requestParams),
                    method: 'DELETE',
                });
            },
        }),
    }); },
});
export var useGetVehicleDetailsQuery = vehicleRegistrationApi.useGetVehicleDetailsQuery, usePostVehicleDetailsMutation = vehicleRegistrationApi.usePostVehicleDetailsMutation, useUpdateVehicleDetailsMutation = vehicleRegistrationApi.useUpdateVehicleDetailsMutation, useDeleteVehicleDetailsMutation = vehicleRegistrationApi.useDeleteVehicleDetailsMutation;
